var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"align-content-space-between",style:({ height: _vm.forcedHeight }),attrs:{"fill-height":""}},[_c('style',{tag:"component"},[_vm._v(" :root { --topDistance: "+_vm._s(_vm.topDistance)+" } ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }